module.exports = __webpack_public_path__ + "static/img/zj-pic6.b27a14f2.png";